import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShiftTimelineComponent } from './components/shift-timeline/shift-timeline.component';
import { ShiftTimelineDraftComponent } from './components/shift-timeline-draft/shift-timeline-draft.component';
import { canMatchFeatureGuardFn } from '@wilson/feature-flags';
import { ShiftTimelineRedirectComponent } from './components/shift-timeline-redirect/shift-timeline-redirect.component';

const routes: Routes = [
  { path: '', component: ShiftTimelineComponent },
  { path: 'redirect', component: ShiftTimelineRedirectComponent },
  {
    path: 'draft',
    component: ShiftTimelineDraftComponent,
    data: {
      breadcrumb: 'page.shift_timeline.draft',
      featureFlag: 'timeline-draft-mode',
    },
    canMatch: [canMatchFeatureGuardFn],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ShiftTimelineRoutingModule {}
